<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="graphics-symbol">
    <path
      fill="currentColor"
      d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0zm3.7 6.7h-1.5c-1.2 0-1.4.6-1.4 1.4v1.8h2.8l-.4 2.8h-2.4V20H9.9v-7.3H7.4V9.9h2.5V7.8c0-2.4 1.5-3.8 3.7-3.8 1 0 1.9.1 2.2.1v2.6z"
    />
  </svg>
</template>
